import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';

/**
 * Needs Refill merchandisers list (PD-13938) — units whose computed stock
 * level is Empty or Low. Filters on the derived `merchandiserFillLevel`
 * (the inventory rollup's stockLevel), applied post-rollup by the backend.
 */
export const needsRefillMerchandisersList: ListBuilderList = {
	id: 'default-merchandisers-needs-refill',
	name: 'Needs Refill',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		merchandiserFillLevel: {
			defaultValue: [
				{ id: 'Empty', label: 'Empty' },
				{ id: 'Low', label: 'Low' },
			],
		},
	},
	columns: createMerchandiserColumns(),
	defaultSortId: 'merchandiser-name',
	sortOrder: 1,
};
